import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DispatcherSignupComponent } from './dispatcher-signup/dispatcher-signup.component';
import { DriverSignUpComponent } from './driver-signup/driver-signup.component';
import { OnBoardingComponent } from './onboarding/onboarding.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'login', slug: 'login' }
  },
  {
    path: 'group-operator/registration',
    component: DispatcherSignupComponent,
    data: { title: 'dispatcher-signup', slug: 'dispatcher-signup' }
  },
  {
    path: 'driver/registration',
    component: DriverSignUpComponent,
    data: { title: 'driver-signup', slug: 'driver-signup' }
  },
  {
    path: 'onboarding',
    component: OnBoardingComponent,
    data: { title: 'onboarding', slug: 'onboarding' }
  },

]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
